import { FONTFACE_CIRCULAR, FONT_NAMES } from './font';
import {
  LIGHT_SOY,
  MEDIUM_SOY,
  MEDIUM_TOFU,
  SOY,
  TOMATO,
  WHITE,
  ERROR
} from 'base/constants/colors';
import {
  BOX_SHADOW_CARD_NORMAL,
  BOX_SHADOW_CARD_SELECTED,
  BOX_SHADOW_APPBAR
} from 'base/constants/shadows';
import outline from 'base/style_mixins/outline';

export default {
  MuiCssBaseline: {
    '@global': {
      '@font-face': [
        FONTFACE_CIRCULAR.reg,
        FONTFACE_CIRCULAR.bold,
        FONTFACE_CIRCULAR.med
      ]
    }
  },
  MuiCard: {
    root: {
      width: '100%',
      height: '100%',
      position: 'relative',
      borderRadius: 8,
      boxShadow: BOX_SHADOW_CARD_NORMAL,
      '&:hover': {
        boxShadow: BOX_SHADOW_CARD_SELECTED,
        bottom: 1
      }
    }
  },
  MuiCardContent: {
    root: {
      height: '100%',
      padding: 20,
      '&:last-child': {
        paddingBottom: 20
      }
    }
  },
  MuiCardActionArea: {
    root: {
      height: '100%'
    },
    focusHighlight: {
      opacity: '0 !important'
    }
  },
  MuiAppBar: {
    root: {
      boxShadow: BOX_SHADOW_APPBAR
    }
  },
  MuiList: {
    root: {
      padding: 0
    }
  },

  MuiListItem: {
    root: {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  MuiCardMedia: {
    root: {
      objectFit: 'cover'
    }
  },
  MuiToolbar: {
    root: {
      justifyContent: 'space-between'
    }
  },
  MuiCardHeader: {
    root: {
      padding: 0
    }
  },
  MuiButtonBase: {
    root: {
      '&$focusVisible': {
        ...outline
      }
    }
  },
  MuiTab: {
    root: {
      fontFamily: FONT_NAMES.med,
      fontSize: '20px !important',
      textTransform: 'capitalize',
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      display: 'flex',
      justifyContent: 'flex-start',
      minWidth: '0 !important',
      marginRight: 24
    },
    wrapper: {
      display: 'flex',
      alignItems: 'flex-start'
    }
  },
  MuiButton: {
    root: {
      fontFamily: FONT_NAMES.med,
      fontSize: 14,
      letterSpacing: 1.25,
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },

    textSecondary: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  },
  MuiCircularProgress: {
    colorPrimary: {
      color: LIGHT_SOY
    }
  },
  MuiSvgIcon: {
    root: {
      fill: LIGHT_SOY
    }
  },
  MuiInputBase: {
    root: {
      fontSize: '14px',
      overflow: 'hidden'
    }
  },
  MuiFormGroup: {
    root: {
      width: '100%'
    }
  },
  MuiFormHelperText: {
    contained: {
      padding: 0,
      marginLeft: 0
    },
    root: {
      '&.Mui-error': {
        color: TOMATO
      }
    }
  },
  MuiSelect: {
    root: {
      width: '100%',
      color: MEDIUM_SOY
    },
    select: {
      width: '100%',
      '&:focus': {
        backgroundColor: WHITE,
        border: '0'
      },
      padding: '19px 12px 13px'
    }
  },
  MuiOutlinedInput: {
    notchedOutline: {
      border: `1px solid ${MEDIUM_TOFU} !important`
    }
  },
  MuiInputLabel: {
    root: {
      transform: 'translate(12px, 22px) scale(1)',
      zIndex: 1
    },
    shrink: {
      color: `${SOY}`,
      transform: 'translate(12px, 14px) scale(0.75) !important',
      '&$focused': {
        color: `${SOY}`
      },
      '&$error': {
        color: ERROR
      }
    }
  },
  MuiFormControl: {
    root: {
      width: '100%'
    }
  },
  MuiLink: {
    root: {
      color: SOY
    }
  },
  MuiFilledInput: {
    root: {
      border: `1px solid ${MEDIUM_TOFU}`,
      borderRadius: '4px',
      transition: 'none',
      color: MEDIUM_SOY,
      backgroundColor: `${WHITE} !important`
    },
    input: {
      top: '8px',
      position: 'relative',
      padding: '17px 12px 18px'
    }
  },
  MuiIconButton: {
    root: {
      fontSize: 14,
      fontFamily: FONT_NAMES.med,
      letterSpacing: 1.25,
      borderRadius: '4px',
      textTransform: 'uppercase',
      padding: 0,
      '&:hover': {
        color: MEDIUM_SOY,
        backgroundColor: 'transparent !important'
      }
    }
  },
  MuiDialog: {
    paper: {
      borderRadius: '8px',
      overflowY: 'visible'
    }
  },
  MuiDialogContent: {
    root: {
      paddingTop: 0,
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
      '&:first-child': {
        paddingTop: 0
      }
    }
  },
  MuiDialogActions: {
    root: {
      display: 'block',
      padding: 0
    }
  },
  MuiDialogTitle: {
    root: {
      paddingTop: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0
    }
  },
  MuiBottomNavigation: {
    root: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: 'auto',
      padding: '20px',
      backgroundColor: WHITE,
      boxShadow: BOX_SHADOW_APPBAR
    }
  }
};
